/* jslint esversion: 6 */
/**
 * Scroll Throttle
 *
 * Throttle the scroll event for better performance.
 *
 * @author Dylan James Wagner
 *
 * @todo review (3 * s.interval), perhaps make variable
 * @todo consider settings.log : true/false
 * @todo consider setting.viewport.scrollTop
 * @todo consider scope of scrolled element and setting. x/y
 */
const $ = window.jQuery;
const s = {
	$window   : $(window),
	timer     : undefined,
	interval  : 250,
	triggered : 0,
};

function init() {

	events();
}

function events() {

	s.$window.on('scroll', function() {
		scrollThrottle();
	});
}

function scrollThrottle() {
	// throttle function to save performance on scroll
	// adjust settings.interval value to change how often the event fires
	var now = new Date().getTime();

	if (!s.timer) {

		// fire immediately on initial scroll
		// if (now - s.triggered > (3 * s.interval)) {
		if (now - s.triggered > s.interval) {

			trigger();
			s.triggered = now;
		}

		s.timer = setTimeout(function() {

			s.timer = null;
			s.triggered = new Date().getTime();
			trigger();

		}, s.interval);
	}
}

function trigger() {
	var scrollTop = s.$window.scrollTop();

	// s.$window.trigger('scrollThrottle');
	s.$window.trigger({
		type      : 'scrollThrottle',
		scrollTop : scrollTop
	});

	// console.log('scrollThrottle: ' + scrollTop); // log scroll throttle
}

export {init as default};
